import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { t } from 'i18next';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';

/**
 * Trigger analyse events where user clicks on pen and open modal inscription.
 * If resourceName is undefined, it's DAF view (analyse_arguments). Else, it's Analyse by resource view.
 */
export const triggerAnalyseTCDEvent = (
    resourceName: string | undefined,
    budgetProposal: BudgetProposalT,
    eventName: 'penModalOpened' | 'pivotGridExport',
) => {
    if (resourceName === undefined) {
        trackEventBudget(
            TRACKABLE_EVENTS.budget.budgetOverview.analyse_arguments[eventName],
            {
                budgetProposal: budgetProposal.name,
                phase: t(`budgetProposal.${budgetProposal.phase}`),
            },
        );
    } else {
        trackEventBudget(
            TRACKABLE_EVENTS.budget.budgetProposal.analyse[eventName],
            {
                budgetProposal: budgetProposal.name,
                phase: t(`budgetProposal.${budgetProposal.phase}`),
                service: resourceName,
            },
        );
    }
};

/**
 * Track event triggered when a user set a new filter in Analyse by Resource view.
 * @param newFilterData the data used to update the filter
 */
export const trackEventEditAnalyseFilter = (
    newFilterData: Partial<SentenceFilterT>,
) => {
    trackEventBudget(
        TRACKABLE_EVENTS.budget.budgetProposal.analyse.saveFilter,
        {
            field: newFilterData.field,
            newValue: newFilterData.value,
        },
    );
};
